<template>
  <div :style="exhibitionConfig ? `background:${exhibitionConfig.invitationEn.backgroundColor};padding-top:${exhibitionConfig.invitationEn.topToContent / 100 + 'rem'}` : 'background:#94928e'" class="exhibition-invita">
    <div v-if="exInfo.company.nameEn" v-wechat-title="exInfo.company.nameEn ? exInfo.company.nameEn : 'Invitation'"></div>
    <div v-else v-wechat-title="'Invitation'"></div>
    <img :src="exhibitionConfig.invitationEn.backgroundUrl" class="ex_details_bg" v-if="exhibitionConfig && exhibitionConfig.invitationEn.backgroundUrl" />
    <div class="invita_content">
      <div class="invita_head">
        <div class="head_top">
          <img :class="{ square_logo: configLogoIsSquare }" :src="exInfo.company.logo" v-if="exInfo.company && exInfo.company.logo" v-load="'oPic'" />
          <img :class="{ square_logo: configLogoIsSquare }" :src="exhibitionInfo.exhibition.logo" v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo" v-load="'oPic'" />
          <img :class="{ square_logo: configLogoIsSquare }" src="@/assets/img/empty.png" v-else />
          <div class="head_info">
            <p class="info_comp_name van-multi-ellipsis--l2">{{ exInfo.company.nameEn }}</p>
            <p class="info_cg">Welcome to visit</p>
            <div class="info_site" v-if="exInfo.boothInfo">
              <p>
                <van-icon color="#fe781d" name="location" style="margin-right: 0.12rem" />
                {{ exInfo.boothInfo }}
              </p>
              <span @click="goToBooth">Go~</span>
            </div>
            <p class="info_tag" v-if="exInfo.categoryEn">
              <i class="iconfont icon-biaoqian1"></i>
              {{ exInfo.categoryEn }}
            </p>
            <!-- <p class="info_tag" v-if="exInfo.category">
              <i class="iconfont icon-biaoqian1"></i>{{ exInfo.category }}
            </p>-->
          </div>
        </div>
        <div class="head_count">
          <div>
            <p>{{ exInfo.talkCount ||exInfo.talkCount==0 ? wCount(exInfo.talkCount) : ' - ' }}</p>
            <span>Talks</span>
          </div>
          <div>
            <p>{{ exInfo.appointmentNumber||exInfo.appointmentNumber==0 ? wCount(exInfo.appointmentNumber) : ' - ' }}</p>
            <!-- <span>咨询</span> -->
            <span>Appointments</span>
          </div>
          <div>
            <p>{{ exInfo.userCount ||exInfo.userCount==0? wCount(exInfo.userCount) : ' - ' }}</p>
            <!-- <span>访客</span> -->
            <span>Visitors</span>
          </div>
          <div>
            <p>{{ exInfo.productNumber||exInfo.productNumber==0 ? wCount(exInfo.productNumber) : ' - ' }}</p>
            <!-- <span>展品</span> -->
            <span>Products</span>
          </div>
          <div>
            <p>{{ exInfo.activityNumber ||exInfo.activityNumber==0? wCount(exInfo.activityNumber) : ' - '}}</p>
            <!-- <span>活动</span> -->
            <span>Activities</span>
          </div>
        </div>
      </div>
      <div :class="{
          no_target: !((exInfo.objectiveTagsEn && exInfo.objectiveTagsEn.length) || exInfo.objectivesEn),
        }" class="comp_info" v-if="
          (exInfo.company.videosEn && exInfo.company.videosEn.url) ||
            (exInfo.company.banners && exInfo.company.banners.length) ||
            exInfo.summaryEn ||
            (exInfo.objectiveTagsEn && exInfo.objectiveTagsEn.length) ||
            exInfo.objectivesEn
        ">
        <div class="comp_banner" v-if="(exInfo.company.videosEn && exInfo.company.videosEn.url) || (exInfo.company.banners && exInfo.company.banners.length)">
          <van-swipe :autoplay="isAutoplay" @change="swiperChange" class="comp_swipe" indicator-color="white">
            <van-swipe-item v-if="exInfo.company.videosEn && exInfo.company.videosEn.url">
              <div class="comp_video">
                <videoPlayer :cover="exInfo.company.videosEn.cover" :url="exInfo.company.videosEn.url" @onPlayerPause="onVideoPause" @onPlayerPlay="onVideoPlay" ref="videoPlays"></videoPlayer>
              </div>
            </van-swipe-item>
            <van-swipe-item :key="ind" v-for="(item, ind) in exInfo.company.banners">
              <img :src="item" v-if="item" v-load="'oExBanner'" />
              <img :key="ind" src="@/assets/img/empty.png" v-else />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div :style="!((exInfo.company.videosEn && exInfo.company.videosEn.url) || (exInfo.company.banners && exInfo.company.banners)) ? 'margin-top:0' : ''" class="comp_brief web_info" v-if="exInfo.company.addressEn || exInfo.company.website">
          <div v-if="exInfo.company.website">
            <span>Web :</span>
            <p>{{ exInfo.company.website }}</p>
          </div>
          <div v-if="exInfo.company.addressEn">
            <span>Addr :</span>
            <p>{{ exInfo.company.addressEn }}</p>
          </div>
        </div>
        <div :style="
            !((exInfo.company.videosEn && exInfo.company.videosEn.url) || (exInfo.company.banners && exInfo.company.banners.length)) &&
            !exInfo.company.email & !exInfo.company.website &&
            !exInfo.company.addressEn
              ? 'margin-top:0'
              : ''
          " class="comp_brief" v-if="exInfo.summaryEn">
          <div :class="{ no_show: !isContShow || !isShowZK }" :content="exInfo.summaryEn" class="cont" style="white-space: pre-wrap;" v-html="$service.replaceSpeace(exInfo.summaryEn)">
            <!-- {{ exInfo.summaryEn }} -->
          </div>
          <span @click="isContShow = !isContShow" class="show_btn" v-if="isShowZK && !isContShow">
            {{ isContShow ? "pack up" : "MORE" }}
            <i :class="isContShow ? 'shang' : ''" class="iconfont icon-right-fill"></i>
          </span>
        </div>
        <div class="comp_target" v-if="(exInfo.objectiveTagsEn && exInfo.objectiveTagsEn.length) || exInfo.objectivesEn">
          <div class="target_title">Objective(s)</div>
          <div class="target_tag" v-if="exInfo.objectiveTagsEn && exInfo.objectiveTagsEn.length">
            <span :key="index" v-for="(item, index) in exInfo.objectiveTagsEn">{{ item }}</span>
          </div>
          <div :class="{ target_show: isTargetConShow }" class="target_con" v-html="$service.replaceSpeace(exInfo.objectivesEn)" v-if="exInfo.objectivesEn">{{ exInfo.objectivesEn }}</div>
          <div style="height: 0.28rem; width: 100%"></div>
          <div @click="isTargetConShow = !isTargetConShow" class="target_btn" v-if="isShowTarGetBtn && !isTargetConShow">
            {{ isTargetConShow ? "pack up" : "MORE" }}
            <i :class="isTargetConShow ? 'shang' : ''" class="iconfont icon-right-fill"></i>
          </div>
        </div>
      </div>
      <!-- 展品 -->
      <exhibitsList></exhibitsList>
      <!-- 活动 -->
      <activityList></activityList>
      <!-- 用户评价 -->
      <!-- <evaluateList style="margin-top:0.2rem" v-if="exInfo.evaluateCount>0" :evalCount="exInfo.evaluateCount" :evalTags="exInfo.evaluateTags"></evaluateList> -->
      <!-- 点赞 -->
      <Fabulous :isExInvitation="true" :isLike="isLike" :likeOpt="likeOpt" :targetId="exhibitorId" :targetType="'exhibitor'" :visitOpt="visitOpt" @likeClick="likeClick" @likeMore="likeMore" @visitMore="visitMore" ref="Fabulous"></Fabulous>

      <!-- 推荐的客服 -->
      <service :inMemberId="inMemberId" v-if="inMemberId"></service>
    </div>
    <div class="shop_footer">
      <div @click="toExhibition" class="f_item">
        <i class="iconfont i_zh icon-zhanshangxiu"></i>
        <p>Home</p>
      </div>
      <div @click="delLove" class="f_item love" v-if="isFollower">
        <i class="iconfont i_love icon-love"></i>
        <p>UnFollow</p>
      </div>
      <div @click="addLove" class="f_item" v-else>
        <i class="iconfont i_love icon-guanzhu-xian"></i>
        <p>Follow</p>
      </div>
      <!--  :class="{ love:isLike }" -->
      <div :class="{ love: isLike }" @click="likeClick" class="f_item">
        <i :class="isLike ? 'icon-dianzanxuanzhong' : 'icon-dianzan'" class="iconfont i_dianzan"></i>
        <!-- :class="isLike ? 'icon-dianzanxuanzhong' : 'icon-dianzan'" -->
        <p>Like</p>
      </div>
      <div class="f_btn" v-if="isReg">
        <span class="van-button already" v-if="exInfo.customerServiceIsAppointmentNumber == 0 || (this.userRole.toUpperCase() == 'EXHIBITOR' && userInfo.inMember.exhibitorId == exhibitorId)">Chat</span>
        <span @click="advisoryClick" class="van-button" v-else>Chat</span>
        <!-- <span class="van-button" @click="advisoryClick">在线咨询</span> -->
        <!-- <span  class="van-button " :class="exInfo.hasReg?'already':''" @click="visitClick">{{exInfo.hasReg?"您已预约":"预约洽谈"}}</span> -->
        <span @click="visitClick" class="van-button">APPOINT</span>
      </div>
      <div class="f_btn" v-else>
        <span @click="LinkToLogin" class="van-button allborder" v-if="login&&login.login">Sign in</span>
        <span @click="regClick" class="van-button allborder" v-else>Register</span>
      </div>
    </div>
    <div class="goto_live" v-if="exInfo.isLiving">
      <gotoLive :info="exInfo.activityLiving"></gotoLive>
    </div>
    <div class="ex_tool">
      <exTool :isInquiry="false" :isLike="isLike" :likeCount="exInfo.likeCount" :shareCount="exInfo.shareCount" @askforClick="askforClick" @like="likeClick" @makeVisit="makeVisit" @share="share"></exTool>
    </div>
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>
    <!-- 索取样品 -->
    <inquiry ref="inquiry"></inquiry>
    <!-- 预约洽谈 -->
    <order ref="order"></order>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { Dialog } from "vant";
import videoPlayer from "./components/videoPlayer";
import exhibitsList from "./components/exhibits-list"; //展品
import activityList from "./components/activity-list"; //活动
import evaluateList from "@/components/evaluate-list"; //用户评价
import gotoLive from "@/components/goto-live";
import exTool from "@/components/ex-tool"; //右侧工具栏
import Fabulous from "@/components/Fabulous"; //点赞
import liveShare from "@/components/live-share/index"; //分享
import inquiry from "@components/inquiry"; //索取样品
import order from "@components/order-model.vue"; // 预约洽谈
import service from "./components/service"; // 客服
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "exhibition-invita",
  data () {
    return {
      isContShow: false,
      isTargetConShow: false,
      swiperIndex: 0,
      autoPlayVal: 3000,
      isAutoplay: 3000, //是否自动播放
      shareV: {
        content: "",
        poster: "",
      },
      isShareV: true,
      isFollower: false,
      isLike: false,
      isShowTarGetBtn: false, //是否显示参展目标展开全部按钮
      isInquiry: false, //是否开启索取样品
      giveExInfo: {}, //查询展商信息
      queryExhibitorUser: {}, //访问人数信息
      queryExhibitorLike: {}, //点赞人数信息
      exInfo: {
        company: {},
      },
      visitOpt: {
        //访问信息
        finished: false,
        page: 1,
        size: 20,
        totalCount: 0,
        items: [],
      },
      likeOpt: {
        //点赞信息
        finished: false,
        page: 1,
        size: 30,
        totalCount: 0,
        items: [],
      },
      isShowZK: false, //展开按键是否显示
      isFangwen: false,
      likeLoading: false,
      followerLoading: false,
    };
  },
  components: {
    videoPlayer,
    exhibitsList,
    activityList,
    evaluateList,
    exTool,
    Fabulous,
    liveShare,
    service,
    inquiry,
    gotoLive,
    order,
  },
  computed: {
    ...mapGetters({
      userId: "getUserId",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
      userInfo: "getUserInfo",
      userRole: "getUserRole",
      exhibitionConfig: "getExhibitionConfig",
      configLogoIsSquare: "getConfigLogoIsSquare",
      hostInfo: "getHostInfo",
      login: "getLogin",
      myAdvisorySetting: 'getMyAdvisorySetting'
    }),
    exhibitorId () {
      return this.$route.params.id;
    },
    inMemberId () {
      return this.$route.query.inMemberId;
    },
    isReg () {
      return this.userInfo && this.userInfo.inMember && this.userInfo.inMember.userRole && this.userInfo.inMember.userRole != "VISITOR" && this.userInfo.inMember.userRole != "Visitor";
    }
  },
  async created () {
    this.$store.commit("setExhibitionId", this.exhibitionId);
    await this.$Myapollo.getUserInfo(this);
    this.$store.commit("company/setExhibitorId", this.exhibitorId);
    this.$Myapollo.addExhibitionView();
    this.addView();
  },
  mounted () {
    this.$Bus.$off("shareOk");
    this.$Bus.$on("shareOk", () => {
      this.exInfo.shareCount += 1;
      // console.log('哈哈，分享成功')
    });
    this.$Bus.$off("shareFail");
    this.$Bus.$on("shareFail", () => {
      // console.log('分享失败')
    });
  },
  watch: {},
  methods: {
    ...mapActions({
      LinkUserEvaluation: "linkTo/LinkUserEvaluation",
      LinkChatTalkUser: "linkTo/LinkChatTalkUser",
      exLike: "company/exLike",
      addCompLove: "company/addCompLove",
      delCompLove: "company/delCompLove",
      addCompView: "company/addCompView", //添加浏览记录
      addViewLikeIpByCountry: "addViewLikeIpByCountry",
      addViewLikeIp: "addViewLikeIp",
      addAppointmentNumber: "company/addAppointmentNumber",
      getShareConfig: "wxShare/getShareConfig", //分享
      LinkFooter: "linkTo/LinkFooter",
      exVisitor: "my/exVisitor", //展商预约参观
      LinkToError: "linkTo/LinkToError",
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
      generateShareTemplate: "wxShare/generateShareTemplate", //关键字替换
      graphqlPost: "en/graphqlPostByZXS", //阿波罗接口方法
      LinkToLogin: 'linkTo/LinkToLogin',
      LinkToReg: 'linkTo/LinkToReg',
      getUserAdvisorySetting: "getUserAdvisorySetting"
    }),
    wCount (value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getCate (arr) {
      let str = "";
      if (arr && arr[0]) {
        for (let i = 0; i < arr.length; i++) {
          str += str ? "," + arr[i].Value : arr[i].Value;
        }
        return str;
      } else {
        return "";
      }
    },
    //获取点赞和关注
    async getFollowAndLikeState () {
      let query = `
          query{
                exhibitorFollowerQuery{
                isrFollow(exhibitorId:"${this.exhibitorId}",userId:"${this.userInfo.userId}")
              }
                exhibitorLikeQuery{
                isLike(exhibitorId:"${this.exhibitorId}",userId:"${this.userInfo.userId}")
            }
        }
        `;
      let opt = {
        query: query,
        variables: {},
      };

      let data = await this.graphqlPost(opt);
      // this.isFollower=this.exInfo.isFollow;
      let res = JSON.parse(JSON.stringify(data.data));
      console.log(data, "???????????????????????");
      this.isFollower = res.exhibitorFollowerQuery.isrFollow;
      this.isLike = res.exhibitorLikeQuery.isLike;
    },
    // 添加浏览记录
    async addView () {
      // let userInfo = {
      //   nickName: this.userInfo.nickName,
      //   avatarUrl: this.userInfo.avatarUrl,
      // };
      let body = {
        targetType: "exhibitor",
        targetId: this.exhibitorId,
        actionType: "view",
      };
      let res = null;
      if (this.userInfo && this.userInfo.country) {
        body.country = this.userInfo.country;
        res = await this.addViewLikeIpByCountry(body);
      } else {
        res = await this.addViewLikeIp(body);
      }
      // this.isFangwen = true;
      this.getInfo();
      this.getVisit(true);
      this.getLike();
    },
    //获得访问信息
    getVisit (isF = false) {
      let query = gql`
        query($query: _Any!) {
          ipActionCountQueryView: ipActionCountQuery {
            page(query: $query) {
              hasNextPage
              pageIndex
              totalCount
              items {
                id
                country
                countryCode
                likeCount
                targetType
                viewCount
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "targetId",
          v: this.exhibitorId,
        },
        Equal_targetType: {
          n: "targetType",
          v: "exhibitor",
        },
        GreaterThan: {
          n: "viewCount",
          v: 0,
        },
      };
      let order = [
        {
          N: "viewCount",
          v: 0,
        },
      ];
      let opt = {
        page: this.visitOpt.page,
        size: this.visitOpt.size,
        where: where,
        order: order,
      };
      this.$apollo.addSmartQuery("ipActionCountQueryView", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only",
        result (data) {
          let res = JSON.parse(JSON.stringify(data.data.ipActionCountQueryView.page));
          res.items.forEach((el) => {
            el.countryCode = el.countryCode.toLowerCase();
          });

          if (this.visitOpt.page == 1) {
            this.visitOpt.items = res.items;
          } else {
            this.visitOpt.items = [...new Set([...this.visitOpt.items, ...res.items])];
          }
          this.visitOpt.page = res.pageIndex;
          this.visitOpt.totalCount = res.totalCount;
          if (!res.hasNextPage) {
            this.visitOpt.finished = true;
          }
          if (isF) {
            this.$refs.Fabulous.init();
          }
        },
        error (err) {
          console.log("err", err);
        },
      });
    },
    //获得点赞信息
    getLike () {
      let query = gql`
        query($query: _Any!) {
          ipActionCountQuery {
            page(query: $query) {
              hasNextPage
              pageIndex
              totalCount
              items {
                id
                country
                countryCode
                likeCount
                targetType
                viewCount
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "targetId",
          v: this.exhibitorId,
        },
        Equal_targetType: {
          n: "targetType",
          v: "exhibitor",
        },
        GreaterThan: {
          n: "likeCount",
          v: 0,
        },
      };
      let order = [
        {
          N: "likeCount",
          v: 0,
        },
      ];
      let opt = {
        page: this.visitOpt.page,
        size: this.visitOpt.size,
        where: where,
        order: order,
      };
      this.$apollo.addSmartQuery("ipActionCountQuery", {
        query: query,
        variables: {
          query: opt,
        },
        fetchPolicy: "network-only", //清理缓存
        result (data) {
          console.log(data, "点赞data");
          let res = JSON.parse(JSON.stringify(data.data.ipActionCountQuery.page));
          res.items.forEach((el) => {
            el.countryCode = el.countryCode.toLowerCase();
          });
          if (this.likeOpt.page == 1) {
            this.likeOpt.items = res.items;
          } else {
            this.likeOpt.items = [...new Set([...this.likeOpt.items, ...res.items])];
          }
          this.likeOpt.page = res.pageIndex;
          this.likeOpt.totalCount = res.totalCount;
          if (!res.hasNextPage) {
            this.likeOpt.finished = true;
          }
        },
        error (err) {
          console.log("err", err);
        },
      });
    },
    //获取展商信息
    getInfo () {
      const query = gql`
        query exhibitor($id: Guid!) {
          giveExInfo: exhibitor(id: $id) {
            banner #主图海报
            id
            video #主图视频
            objectivesEn #参展目标
            activityLiving {
              acvitityType
              id
              liveAuditState
              externalLink
              hasLive
            }
            customerServiceIsAppointmentNumber
            customerServiceNumber #联络人数量
            summaryEn #参展公司简介
            objectiveTagsEn #参展目标标签 多个按;隔开
            appointmentNumber #预约
            userCount #浏览人数
            shareCount #分享次数
            likeCount #点赞数
            talkCount #洽谈
            advisoryCount #咨询人数
            activityCount #活动数
            activityNumber
            evaluateCount #评价数
            boothInfo
            exhibition {
              banners {
                covers
              }
              bannerEn
              banner
              nameEn
              startData
              endDate
            }
            exhibitionId
            businesses(num: 3) {
              isSample
            }
            category #产品类别
            categoryEn
            evaluateTags {
              #评价标签
              evaluateCount #评价数
              name
            }
            productNumber #产品数量
            isLiving #是否正在直播
            compId #公司id
            company {
              #公司信息
              id
              name
              nameEn
              logo
              region #地区
              regionEn
              banners #banner
              videos #视频
              videosEn
              country
              countryEn
              province
              provinceEn
              county
              countyEn
              city
              cityEn
              address
              addressEn
              website
              email
            }
          }
        }
      `;
      this.$apollo.addSmartQuery("giveExInfo", {
        query: query,
        variables: {
          id: this.exhibitorId,
          userId: this.userInfo.userId,
          memberId: this.userInfo.id,
        },
        fetchPolicy: "network-only", //清理缓存
        async result (res) {
          let data = JSON.parse(JSON.stringify(res.data.giveExInfo));
          if (data) {
            if (this.userInfo) {
              this.getFollowAndLikeState();
            }
            if (data.company.videos && data.company.videos.indexOf("{") !== -1) {
              data.company.videos = JSON.parse(data.company.videos);
            }
            if (data.company.videosEn && data.company.videosEn.indexOf("{") !== -1) {
              data.company.videosEn = JSON.parse(data.company.videosEn);
            }
            if (data.company.banners) {
              data.company.banners = data.company.banners.split(";");
            }
            if (data.category && data.category.indexOf("[") !== -1) {
              let cateArr = JSON.parse(data.category);
              data.category = this.getCate(cateArr);
            }
            if (data.categoryEn && data.categoryEn.indexOf("[") !== -1) {
              let cateArr = JSON.parse(data.categoryEn);
              data.categoryEn = this.getCate(cateArr);
            }
            data.evaluateCount = this.wCount(data.evaluateCount); //评价数
            for (let i = 0; i < data.evaluateTags.length; i++) {
              data.evaluateTags.evaluateCount = this.wCount(data.evaluateTags.evaluateCount);
            }
            if (data.objectiveTagsEn) {
              data.objectiveTagsEn = data.objectiveTagsEn.split(";");
            }
            if (data.isLiving) {
              data.activityLiving.company = { logo: data.company.logo };
            }
            this.exInfo = data;
            this.$store.commit("setExhibitionId", data.exhibitionId);
            await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, "");
            this.isInquiry = false;
            if (this.exInfo.businesses.length) {
              for (let i = 0; i < this.exInfo.businesses.length; i++) {
                if (this.exInfo.businesses[i].isSample) {
                  this.isInquiry = true;
                  break;
                }
              }
            }
            this.isFollower = this.exInfo.isFollow;
            this.$nextTick(async () => {
              if (document.querySelector(".target_con") && document.querySelector(".target_con").scrollHeight > 60) {
                this.isShowTarGetBtn = true;
              } else {
                this.isShowTarGetBtn = false;
              }
              if (document.querySelector(".cont") && document.querySelector(".cont").scrollHeight >= 65) {
                this.isShowZK = true;
              } else {
                this.isShowZK = false;
              }
              this.getShareData();
              this.checkShareInfo();
            });
            if (data.category && data.category.indexOf("[") !== -1) {
              let cateArr = JSON.parse(data.category);
              data.category = this.getCate(cateArr);
            }
          } else {
            this.LinkToError();
          }
        },
      });
    },
    //设置分享信息
    checkShareInfo () {
      this.$store.commit("wxShare/setFromType", 1);
      let userInfo = {
        name: this.userInfo.nickName || this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
      };
      let body = {
        compId: this.exInfo.compId,
        exhibitionId: this.exhibitionId,
        exhibitorId: this.exhibitorId,
        userId: this.userInfo.userId,
        userInfo: JSON.stringify(userInfo),
        fromType: 1,
      };
      this.$store.commit("wxShare/setFromData", body);
    },
    //轮播改变
    swiperChange (index) {
      this.swiperIndex = index;
      if (this.isAutoplay == "-") {
        //如果改变的时候视频正在播放，则暂停
        this.$refs.videoPlays.swiperChange();
        this.isAutoplay = this.autoPlayVal;
      }
    },
    //视频播放
    onVideoPlay () {
      this.isAutoplay = "-";
    },
    //视频暂停
    onVideoPause (index) {
      this.isAutoplay = this.autoPlayVal;
    },
    //评价
    goToEvaluation () {
      if (!this.userInfo.phone) {
        this.$Myapollo.unverifiedDialog(this);
        return;
      }
      this.LinkUserEvaluation(this.exhibitorId);
    },
    async addLove () {
      if (this.followerLoading) {
        return
      }
      // 展商关注
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
        return;
      }
      this.followerLoading = true;
      let userInfo = {
        name: this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
        nickName: this.userInfo.nickName,
      };
      let opt = {
        compId: this.exInfo.compId,
        exhibitionId: this.exhibitionId,
        exhibitorId: this.exhibitorId,
        userId: this.userInfo.userId,
        userInfo: JSON.stringify(userInfo),
      };
      let result = await this.addCompLove(opt);
      // console.log(result,'213')
      if (result.result) {
        this.isFollower = true;
        this.$toast.success("Success");
      } else {
        this.isFollower = false;
        this.$toast.fail(result.message);
      }
      this.followerLoading = false;
    },
    async delLove () {
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
        return;
      }
      // 取消关注
      let body = {
        exhibitorId: this.exhibitorId,
        userId: this.userInfo.userId,
      };
      let result = await this.delCompLove(body);
      // console.log(result,'213
      if (result.result) {
        this.isFollower = false;
        this.$toast.success("Cancel");
      } else {
        this.isFollower = true;
        this.$toast.success(result.message);
      }
    },
    //点赞组件
    //点赞更多
    likeMore () {
      if (this.likeOpt.finished) return;
      this.likeOpt.page += 1;
      this.getLike();
    },
    //访问更多
    visitMore () {
      if (this.visitOpt.finished) return;
      this.visitOpt.page += 1;
      this.getVisit();
    },
    //点赞组件结束
    //免费咨询
    advisoryClick () {
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
        return;
      }

      if (this.userRole.toUpperCase() == "VISITOR") {
        let opt = {
          originType: "exhibitor",
          originId: this.exhibitorId,
          originRemark: this.exInfo.company.name,
        };
        this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId, opt);
        return;
      }
      if (this.userInfo && this.userInfo.inMember.isBlacklist) {
        this.$toast.fail("You do not have access");
        return;
      }
      if (this.exInfo && this.exInfo.id) {
        this.addAppointmentNumber(this.exInfo.id);
      }
      let opt = {
        exhibitorId: this.exhibitorId,
        userId: this.userInfo.userId,
      };
      this.LinkChatTalkUser(opt); //用户
    },
    regClick () {
      let opt = {
        originType: "exhibitor",
        originId: this.exhibitorId,
        originRemark: this.exInfo.company.name,
      };
      this.LinkToReg(opt)
    },
    //预约参观
    async visitClick () {
      // if(this.exInfo.hasReg){
      //   return
      // }
      if (!this.userInfo) {
        this.$Myapollo.NoUserInfo(this);
        return;
      }
      if (this.userRole.toUpperCase() == "VISITOR") {
        let opt = {
          originType: "exhibitor",
          originId: this.exhibitorId,
          originRemark: this.exInfo.company.name,
        };
        this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId, opt);
      } else if (this.userInfo && this.userInfo.inMember.isBlacklist) {
        this.$toast.fail("You do not have access");
        return;
      } else {
        if (!this.myAdvisorySetting || this.myAdvisorySetting.appointmentDayNumber == 0) {
          await this.getUserAdvisorySetting()
        }
        // console.log(this.myAdvisorySetting,'设置的s')
        if (this.myAdvisorySetting.appointmentDayNumber > 0) {
          this.makeVisit();
        } else {
          this.$toast.fail("You have reached the maximum number of appointments");
        }
      }
    },
    //侧边预约参观
    makeVisit () {
      this.$refs.order.open();
      return;
      Dialog.confirm({
        title: "预约参展",
        message: "是否向该展商提交预约信息",
      })
        .then(async () => {
          let opt = {
            exhibitionId: this.exhibitionId,
            exhibitorId: this.exhibitorId,
            memberId: this.userInfo.id,
          };
          // console.log(opt);
          let res = await this.exVisitor(opt);
          // console.log(res);
          if (res.result) {
            this.$toast.success("Success to send");
            this.exInfo.hasReg = true;
          } else {
            this.$toast.fail("Failed to send ");
          }
          // on confirm
        })
        .catch(() => {
          this.$toast.fail("取消预约");
          // on cancel
        });
    },
    //侧边和点赞组件点赞
    async likeClick () {
      if (this.likeLoading) {
        return
      }

      let body = {
        targetType: "exhibitor",
        targetId: this.exhibitorId,
        actionType: "like",
      };
      let res = null;
      if (this.userInfo) {
        if (this.isLike) {
          this.$toast("You've already liked it");
          return;
        }
        this.likeLoading = true;
        let userInfo = {
          name: this.userInfo.nickName || this.userInfo.name || "",
          avatarUrl: this.userInfo.avatarUrl,
          nickName: this.userInfo.nickName,
          flagStyle: this.userInfo.flagStyle || "",
        };
        let opt = {
          compId: this.exInfo.compId,
          exhibitionId: this.exhibitionId,
          exhibitorId: this.exhibitorId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
        };
        let res1 = await this.exLike(opt);
        if (res1.result) {
          this.$toast.success("Like success");
          this.$apollo.queries.giveExInfo.refresh();
          // this.$apollo.queries.queryExhibitorLike.refresh();
        } else {
          this.$toast.success("Like failure");
        }
        if (this.userInfo.country) {
          body.country = this.userInfo.country;
          res = await this.addViewLikeIpByCountry(body);
        }
        return;
      } else {
        this.likeLoading = true;
        res = await this.addViewLikeIp(body);
      }
      if (res.result) {
        this.$toast.success("Like success");
        // this.$apollo.queries.giveExInfo.refresh();
        // this.$apollo.queries.queryExhibitorLike.refresh();
      } else {
        this.$toast.fail("Like failure");
      }
      this.likeLoading = false;
    },
    //侧边索取样品
    askforClick () {
      this.$store.commit("company/setExhibitorId", this.exhibitorId);
      this.$store.commit("company/setCompanyId", this.companyId);
      let exInfo = {
        compLogo: this.exInfo.company.logo,
        compName: this.exInfo.company.name,
        boothInfo: this.exInfo.boothInfo,
      };
      this.$refs.inquiry.open(exInfo);
    },
    //去展会  首页
    toExhibition () {
      let opt = {
        url: `/home/${this.exhibitionId}`,
      };
      this.LinkFooter(opt);
    },
    //去逛逛，去展位图
    goToBooth () {
      let opt = {
        url: `/boothView/${this.exhibitionId}?exhibitorId=${this.exhibitorId}`,
      };
      this.LinkFooter(opt);
    },
    // 自定义分享(展商设置)
    async getShareVal () {
      let res = await this.getShareConfig(this.exhibitorId);
      if (res && res) {
        this.shareV = JSON.parse(res);
      }
      this.isShareV = true;
    },
    // 自定义分享(主办设置)
    async getShareValByHost () {
      let res = await this.getSettingShare({
        id: this.exhibitionId,
        name: "share.exhibitor.en.config",
      });
      if (res && res) {
        let shareMsg = JSON.parse(res);
        let objTemp = {
          CompanyName: this.exInfo.company.nameEn || "",
          booth: this.exInfo.boothInfo || "",
        };
        let opt = {
          temp: shareMsg.content,
          objTemp: objTemp,
        };
        let optdes = {
          temp: shareMsg.des,
          objTemp: objTemp,
        };
        let msg = await this.generateShareTemplate(opt);
        let des = await this.generateShareTemplate(optdes);
        shareMsg.content = msg;
        shareMsg.des = des;
        this.shareV = shareMsg;
      }
      this.isShareV = true;
    },
    //侧边分享点击
    async share () {
      let country = this.exInfo.company.countryEn ? this.exInfo.company.countryEn : "China";
      let province = this.exInfo.company.provinceEn ? "/" + this.exInfo.company.provinceEn : "";
      let city = this.exInfo.company.cityEn ? "/" + this.exInfo.company.cityEn : "";
      let addr = country + province + city;
      let bannerUrl = this.exInfo.company.banners && this.exInfo.company.banners.length ? this.exInfo.company.banners : null;
      bannerUrl = bannerUrl || [];
      if (!bannerUrl.length) {
        bannerUrl = [this.exInfo.exhibition.bannerEn];
      }
      if (!Array.isArray(bannerUrl)) {
        bannerUrl = [bannerUrl];
      }
      let opt = {
        title: "Recommend a brand exhibitor for you",
        bannerTitle: this.exInfo.company.nameEn, //公司名字
        subhead: this.exInfo.boothInfo || "",
        banner: bannerUrl.length ? bannerUrl.slice(0, 3) : [],
        type: "invite",
      };
      if (this.shareV && this.shareV.poster) {
        opt.banner = [this.shareV.poster]
      }
      console.log('this.shareV', this.shareV);
      this.$nextTick(() => {
        this.$refs["liveShare"].open(opt);
      });
      await true;
    },
    //分享标题，内容，图片
    async getShareData () {
      await this.getShareValByHost(); // 主办设置
      await this.getShareVal(); // 展商设置
      let time = moment(this.exInfo.exhibition.startData).format("YYYY/MM/DD");
      let title = this.shareV.content ? this.shareV.content : this.exInfo.company.nameEn + " invites you to visit " + this.exInfo.exhibition.nameEn;
      let desc = this.shareV.des ? this.shareV.des : time + "\r\n" + this.exInfo.boothInfo;
      let imgUrl = this.exInfo.company.logo;
      let shareData = {
        title: title,
        desc: desc,
        imgUrl: imgUrl,
      };
      this.$nextTick(() => {
        this.$refs.liveShare.shareTo(shareData);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.exhibition-invita {
  min-height: 100vh;
  position: relative;
  padding-top: 4.68rem;
  padding-bottom: 1rem;
  box-sizing: border-box;
  .ex_details_bg {
    position: absolute;
    width: 100%;
    height: auto;
    max-height: 100%;
    top: 0;
  }
  .invita_content {
    color: #333;
    position: relative;
    z-index: 1;
    padding: 0 0.3rem;
    .invita_head {
      padding: 0.5rem 0 0.4rem;
      background: #fff;
      border-radius: 0.3rem;
      .head_top {
        display: flex;
        padding: 0 0.3rem;
        img {
          width: 1.4rem;
          height: 1.4rem;
          border-radius: 50%;
          flex-shrink: 0;
          margin-right: 0.24rem;
          box-shadow: 0px 0px 0.1rem 0px rgba(0, 0, 0, 0.4);
        }
        .head_info {
          width: calc(100% - 1.64rem);
          > p,
          .info_site {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 0.26rem;
            line-height: 1.3;
            margin-top: 0.16rem;
            &.info_comp_name {
              white-space: inherit;
              font-weight: bold;
              margin-top: 0;
              font-size: 0.34rem;
              min-height: 0.36rem;
            }
            &.info_cg {
              font-size: 0.24rem;
              color: #999;
            }
            &.info_site {
              display: flex;
              align-items: center;
              p {
                font-size: 0.26rem;
                transform: translateY(-0.02rem);
                .van-icon {
                  transform: translateY(0.02rem);
                }
                color: #4d4d4d;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              span {
                flex-shrink: 0;
                color: #13367b;
                margin-left: 0.26rem;
                font-size: 0.26rem;
              }
            }
            &.info_tag {
              color: #666;
              margin-left: -0.03rem;
              .iconfont {
                color: #1890ff;
                vertical-align: text-top;
                display: inline-block;
                transform: scale(1.2);
                margin-right: 0.08rem;
              }
            }
          }
        }
      }
      .head_count {
        margin-top: 0.46rem;
        color: #666;
        display: flex;
        justify-content: space-between;
        height: 0.7rem;
        padding: 0.14rem 0 0.05rem;
        > div {
          width: 25%;
          border-right: 1px solid #dddddd;
          text-align: center;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          p {
            font-weight: bold;
            font-size: 0.3rem;
            margin-top: -0.1rem;
            margin-bottom: 0.08rem;
          }
          span {
            font-size: 0.22rem;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }
  .comp_info {
    margin-top: 0.2rem;
    padding: 0.3rem 0.25rem 0;
    background: #fff;
    border-radius: 0.3rem;
    &.no_target {
      padding-bottom: 0.3rem;
    }
    .comp_video {
      width: 100%;
      height: 3.6rem;
      border-radius: 0.2rem;
      background: #fff;
      border-radius: 0.3rem;
      .comp_video {
        width: 100%;
        height: 3.6rem;
        border-radius: 0.2rem;
        background: #fff;
        overflow: hidden;
      }
    }
    .comp_banner {
      width: 100%;
      height: 3.6rem;
      border-radius: 0.2rem;
      background: #fff;
      overflow: hidden;
      .comp_swipe {
        width: 100%;
        height: 100%;
        .van-swipe-item {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .comp_brief {
      border-radius: 0.05rem;
      background: #eee;
      margin-top: 0.3rem;
      padding: 0.2rem 0.2rem;
      &.web_info {
        font-size: 0.26rem;
        > div {
          color: #333;
          margin-bottom: 0.1rem;
          display: flex;
          line-height: 0.36rem;
          &:last-child {
            margin-bottom: 0;
          }
          span {
            color: #666;
            display: block;
            width: 0.9rem;
            flex-shrink: 0;
            text-align: right;
            margin-right: 0.06rem;
          }
        }
      }
      .cont {
        line-height: 0.42rem;
        background: #eee;
        position: relative;
        font-size: 0.26rem;
        &.no_show {
          font-size: 0.26rem;
          max-height: 1.3rem;
          overflow: hidden;
          color: #eee;
          &::before,
          &::after {
            content: attr(content);
            overflow: hidden;
            position: absolute;
            width: 100%;
            left: 0;
            top: 0;
            color: #333;
            font-size: 0.26rem;
            line-height: 0.42rem;
          }
          &::before {
            z-index: 2;
            max-height: 0.42rem;
            background: #eee;
          }
          &::after {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            box-sizing: border-box;
            -webkit-line-clamp: 3;
          }
        }
      }
      .show_btn {
        width: 100%;
        margin-bottom: 0.04rem;
        display: block;
        text-align: center;
        color: #595757;
        .iconfont {
          color: #999;
          display: inline-block;
          transform: rotate(90deg) translateX(1px);
          &.shang {
            transform: rotate(-90deg) translateX(-1px);
          }
        }
      }
    }
    .comp_target {
      margin-top: 0.5rem;
      .target_title {
        font-size: 0.3rem;
        color: #333;
        font-weight: 600;
        span {
          font-size: 0.2rem;
          color: #999;
          font-weight: normal;
          margin-left: 0.2rem;
        }
      }
      .target_tag {
        margin-top: 0.2rem;
        display: flex;
        flex-wrap: wrap;
        margin-right: -0.2rem;
        margin-bottom: -0.2rem;
        span {
          padding: 0 0.19rem;
          height: 0.42rem;
          display: flex;
          align-items: center;
          border: 1px solid #ff5c00;
          border-radius: 0.03rem;
          color: #ff5c00;
          font-size: 0.22rem;
          margin: 0 0.2rem 0.2rem 0;
        }
      }
      .target_con {
        line-height: 0.36rem;
        font-size: 0.26rem;
        color: #333;
        margin-top: 0.2rem;
        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        transition: all 0.3s;
        &.target_show {
          display: block;
        }
      }
      .target_btn {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 0.75rem;
        width: calc(100% + 0.5rem);
        border-top: 1px solid #e6e6e6;
        color: #999;
        margin-left: -0.25rem;
        .iconfont {
          color: #999;
          display: inline-block;
          transform: rotate(90deg) translateX(1px);
          &.shang {
            transform: rotate(-90deg) translateX(-1px);
          }
        }
      }
    }
  }
  .goto_live {
    position: fixed;
    top: 1.2rem;
    right: 0.65rem;
    z-index: 99;
  }
  .shop_footer {
    display: flex;
    height: 0.98rem;
    width: 100%;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
    box-sizing: content-box;
    z-index: 10;
    .f_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      color: #808080;
      padding-top: 0.05rem;
      border-right: 1px solid #eee;
      width: 1.09rem;
      &.love {
        color: #ff5c00;
        .iconfont {
          color: #ff5c00;
        }
      }
      .iconfont {
        font-size: 0.58rem;
        &.i_love {
          transform: scale(1.1);
        }
        &.i_dianzan {
          font-size: 0.53rem;
        }
        &.i_zh {
          transform: scale(1.3);
        }
      }
      p {
        font-size: 0.2rem;
        position: relative;
        top: -0.1rem;
      }
    }
    .f_btn {
      flex-grow: 1;
      display: flex;
      padding: 0.13rem 0.24rem;
      .van-button {
        height: 0.72rem;
        line-height: 0.72rem;
        font-size: 0.28rem;
        width: 100%;
        color: #fff;
        text-align: center;
        display: block;
        position: relative;
        .hiddenBtn {
          width: 100%;
          height: 100%;
          display: block;
          background: black;
          color: #fff;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
        }
        &:first-child {
          border-radius: 0.06rem 0 0 0.06rem;
          background: linear-gradient(90deg, #f10100 0%, #ff4e17 100%);
          &.allborder {
            border-radius: 0.06rem;
          }
        }
        &:last-child {
          border-radius: 0 0.06rem 0.06rem 0;
          background: linear-gradient(
            to left,
            rgb(255, 186, 0),
            rgb(255, 166, 0)
          );
          &.allborder {
            border-radius: 0.06rem;
          }
        }
        &.already {
          background: #999;
          color: #fff;
        }
      }
    }
  }
  .ex_tool {
    position: fixed;
    bottom: 1.18rem;
    right: 0.3rem;
    z-index: 1;
  }
}
</style>
